<div class="iframe-page-container">
	<h2 class="layout-heading">
		Automated Insights
	</h2>
	<app-automated-insights-report class="iframe-container"></app-automated-insights-report>
</div>
